import { render, staticRenderFns } from "./NgTextareaKeyboard.vue?vue&type=template&id=4dc6bbc4"
import script from "./NgTextareaKeyboard.vue?vue&type=script&lang=js"
export * from "./NgTextareaKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports